import clsx from 'clsx';

import type { ButtonProps } from './Button';
import s from './Button.module.scss';
import ButtonOutlinedError from './ButtonOutlinedError';

const ButtonOutlinedErrorSmall = ({ className, ...props }: ButtonProps) => (
  <ButtonOutlinedError className={clsx(s.small, className)} {...props} />
);

export default ButtonOutlinedErrorSmall;
